import { useEffect } from 'react';
import type { SetState } from 'shared/src/types';

type UseSetTitleProps = {
  setTitle: SetState<string | undefined>;
  title?: string;
};
/**
 * - 아토믹 화면이기에 title을 알 수 없음.
 * ㄸ라서 ScreensResult에서 api를 통해 title을 받아서 설정해줍니다.
 */
export const useSetTitle = ({ setTitle, title }: UseSetTitleProps) => {
  useEffect(() => {
    if (!title) {
      return;
    }

    setTitle(title);
  }, [title, setTitle]);
};
